(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[119],{

/***/ 3968:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LandingPage": function() { return /* binding */ LandingPage; },
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _tm_insurance_analytics__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2182);
/* harmony import */ var _tm_insurance_navigation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2817);
/* harmony import */ var _tm_insurance_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1725);
/* harmony import */ var _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4928);
/* harmony import */ var _tm_static_pages__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3984);
/* harmony import */ var _tm_static_partnerContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8524);
/* harmony import */ var _tm_ui_widgets__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7109);
/* harmony import */ var _tm_ui_widgets_hoc__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3837);
/* harmony import */ var _tm_ui_hoc__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7800);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2322);











var analytics = (0,_tm_insurance_analytics__WEBPACK_IMPORTED_MODULE_1__/* .getAnalytics */ .I)();
var __N_SSP = true;
function LandingPage(_ref) {
  var data = _ref.data,
      _ref$device = _ref.device,
      device = _ref$device === void 0 ? "mobile" : _ref$device,
      error = _ref.error,
      hasPartnerAuth = _ref.hasPartnerAuth,
      partner = _ref.partner,
      referrer = _ref.referrer,
      _ref$cmp = _ref.cmp,
      cmp = _ref$cmp === void 0 ? "" : _ref$cmp,
      _ref$experiment = _ref.experiment,
      experiment = _ref$experiment === void 0 ? "" : _ref$experiment;
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    // migrate this to server referrer
    var referrer = document.referrer;
    var hostname = referrer ? new URL(referrer).hostname : "";

    if (cmp === "" && (hostname === "www.makemytrip.com" || hostname === "www.goibibo.com")) {
      cmp = "secondary_icon";
    }

    sessionStorage.setItem("cmp", cmp);
  }, []);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(""),
      activeModal = _useState[0],
      setActiveModal = _useState[1];

  var goToMyOrders = function goToMyOrders() {
    analytics === null || analytics === void 0 ? void 0 : analytics.trackLandingEvents({
      actionType: "my_orders_clicked"
    });
    var authCookie = (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_3__/* .getCookieByName */ .A7)("mmt-auth") || (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_3__/* .getCookieByName */ .A7)("OAUTH-GOIBIBO");

    if (authCookie) {
      _tm_insurance_navigation__WEBPACK_IMPORTED_MODULE_2__/* .navigationActions.navigateToOrderListing */ .e.navigateToOrderListing();
    } else {
      setActiveModal === null || setActiveModal === void 0 ? void 0 : setActiveModal("LOGIN");
    }
  };

  var comp = partner === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_4__.PARTNER.GI ? (0,_tm_ui_hoc__WEBPACK_IMPORTED_MODULE_9__/* .withGIInsuranceHeader */ .HC)( /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_tm_static_partnerContext__WEBPACK_IMPORTED_MODULE_6__/* .PartnerContextProvider */ .L, {
    partnerType: _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_4__.PARTNER.GI,
    "data-test-id": "comp-PartnerContextProvider",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_tm_static_pages__WEBPACK_IMPORTED_MODULE_5__/* .InsuranceLanding */ .pB, {
      setActiveModal: setActiveModal,
      data: data,
      "data-test-id": "comp-InsuranceLanding"
    })
  }), {
    Wrapper: _tm_static_pages__WEBPACK_IMPORTED_MODULE_5__/* .InsuranceGiLandingPageMainWrapper */ .Bk,
    forceLogin: !hasPartnerAuth
  }, "Secure International Travel", true, goToMyOrders) : (0,_tm_ui_hoc__WEBPACK_IMPORTED_MODULE_9__/* .withMMTInsuranceHeader */ .ZA)( /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_tm_static_partnerContext__WEBPACK_IMPORTED_MODULE_6__/* .PartnerContextProvider */ .L, {
    partnerType: _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_4__.PARTNER.MMT,
    "data-test-id": "comp-PartnerContextProvider",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_tm_static_pages__WEBPACK_IMPORTED_MODULE_5__/* .InsuranceLanding */ .pB, {
      setActiveModal: setActiveModal,
      data: data,
      "data-test-id": "comp-InsuranceLanding"
    })
  }), {
    type: hasPartnerAuth ? "dualHeader" : "singleHeader",
    Wrapper: _tm_static_pages__WEBPACK_IMPORTED_MODULE_5__/* .InsuranceLandingPageMainWrapper */ .x1,
    activeModal: activeModal ? "LOGIN" : undefined,
    onModalChange: function onModalChange(modal) {
      return setActiveModal(modal);
    },
    forceLogin: !hasPartnerAuth
  }, "Secure International Travel", true, goToMyOrders);
  return (0,_tm_ui_hoc__WEBPACK_IMPORTED_MODULE_9__/* .withError */ .AQ)((0,_tm_ui_widgets_hoc__WEBPACK_IMPORTED_MODULE_8__/* .withReferrerProvider */ .ut)((0,_tm_ui_widgets__WEBPACK_IMPORTED_MODULE_7__/* .withDeviceProvider */ .JK)((0,_tm_ui_widgets_hoc__WEBPACK_IMPORTED_MODULE_8__/* .withExperimentTrackingStringProvider */ .IV)(comp, experiment), device), referrer), error, "LANDING");
}
/* harmony default export */ __webpack_exports__["default"] = (LandingPage);

/***/ }),

/***/ 1525:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/insurance",
      function () {
        return __webpack_require__(3968);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [147,489,774,888,179], function() { return __webpack_exec__(1525); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);